export default "__VITE_ASSET__Cci77dG9__"